import type { ReactElement } from 'react';
import { components, MenuListProps } from 'react-select';
import { Icon } from '../../../icons/Icon.component';
import { Group } from '../../../containers/Group/Group.component';
import { Text } from '../../../typography';
import { ILegacySelectOptionData, LegacySelectOptionGroup } from '../Select.types';

type CreatableMenuListProps = MenuListProps<ILegacySelectOptionData, boolean, LegacySelectOptionGroup>;

const SelectMenuList = () => (
  <Group fullWidth alignItems={'center'} ml={3} my={2}>
    <Icon icon={'arrow-turn-down-left-regular'} />
    <Text lineHeight={'dense'} size={12}>
      Add new option
    </Text>
  </Group>
);

// react-select marks the option that a creatable select offers to create with this field.
const ReactSelectNewOptionProp = '__isNew__';

const isNewOption = (option: ILegacySelectOptionData | LegacySelectOptionGroup): boolean =>
  'options' in option ? false : option[ReactSelectNewOptionProp] === true;

export const CreatableMenuList =
  () =>
  ({ options, ...props }: CreatableMenuListProps): ReactElement => {
    const newOption = options.find(isNewOption);

    return (
      <components.MenuList<ILegacySelectOptionData, boolean, LegacySelectOptionGroup> options={options} {...props}>
        {newOption && <SelectMenuList />}
        {props.children}
      </components.MenuList>
    );
  };

CreatableMenuList.displayName = 'CreatableSelectMenuList';
